import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles.css'

async function start() {
  // Dev-only fixture mode: `VITE_MOCK_API=1` (or `pnpm dev:mock`). Statically false in
  // production builds, so the mocks are tree-shaken away.
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === '1') {
    const { installMockApi } = await import('./mocks/install')
    installMockApi()
  }
  const root = document.getElementById('root')
  if (!root) throw new Error('Missing #root element')
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void start()
